import dayjs from 'utils/dayjs';
import Config from '@/config/index';
import { v4 as uuidV4 } from 'uuid';
import SearchTracking, { SEARCH_TRACKING_ACTIONS } from 'utils/search-tracking';
import { getAirportFacilities } from 'api/search-v2/airport/spot/getAirportFacilities';
import { notify } from '../notification/notification-actions';
import trackErrorMessageDisplayed from 'segment/events/error-message-displayed';
import { getWebExperimentCookie } from 'utils/web-experiment';
export const SPOTS_GET_AIRPORT_V2 = 'SPOTS_GET_AIRPORT_V2';
function handleError(dispatch, error) {
    trackErrorMessageDisplayed({
        message: 'Error fetching spots',
        screen: 'search',
        action: 'fetching spots',
    });
    dispatch(notify({
        id: uuidV4(),
        type: 'error',
        message: 'Error fetching spots',
    }));
    return {
        error: error?.data,
    };
}
export const loadSpotsAirportV2 = () => {
    return (dispatch, getState) => {
        const prevState = getState();
        const searchRequestState = prevState.searchRequest;
        const { starts, ends, operator_id: operatorId, rebook_reservation_id: rebookId, filterSpot, } = searchRequestState;
        const destination = prevState.destination.data;
        const iataCode = destination.airport.iata_code;
        const userState = prevState.user;
        const { data: { isAdmin }, } = userState;
        const timezone = prevState.city.data.timezone;
        const fingerprint = getWebExperimentCookie();
        SearchTracking.updateAction(SEARCH_TRACKING_ACTIONS.SEARCH);
        const { sessionUUID, searchUUID, actionUUID, action, } = SearchTracking.getValues();
        /* eslint-disable camelcase */
        return dispatch({
            type: SPOTS_GET_AIRPORT_V2,
            payload: getAirportFacilities({
                iata: iataCode,
                starts: dayjs(starts).format(Config.craigApiDateTimeFormat),
                ends: dayjs(ends).format(Config.craigApiDateTimeFormat),
                operator_id: operatorId,
                session_id: sessionUUID,
                search_id: searchUUID,
                action_id: actionUUID,
                action,
                fingerprint,
                // show_unavailable is a valid API param but not in the generated type
                ...(isAdmin ? { show_unavailable: isAdmin } : {}),
            }, {
                userRequestedStarts: dayjs(starts).format(Config.craigApiDateTimeFormat),
                userRequestedEnds: dayjs(ends).format(Config.craigApiDateTimeFormat),
                timezone,
                rebookId,
                filterSpot,
            }).then((response) => {
                return {
                    results: response,
                };
            }),
        }).catch((error) => handleError(dispatch, error));
        /* eslint-enable camelcase */
    };
};
